<ng-container *ngIf="property">
<ng-container [ngSwitch]="property.PropertyFormControlType.toUpperCase()">
    <ng-container *ngSwitchCase="'TEXTBOX'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <!-- <input *ngIf="!property.IsAutoComplete" [attr.name]="property.PropertyName" hidden>  -->
        <div *ngIf="property.PropertyValidation; else noValidate" class="property-group">
          <input #textbox type="text"
          [id]="property.PropertyName"
          [ngClass]="{ 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid, 'uppercase': property.PropertyDisplayFormat == 'UPPER' }"
          [value]="property.PropertyValueDisplay" 
          [name]="property.PropertyName"
          [attr.name]="property.PropertyName"
          autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'off'}}"
          [(ngModel)]="property.PropertyValueDisplay" 
          (change)="onValueChange(property, textbox.value, PropertyValue)"
          #PropertyValue="ngModel"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [pattern]="property.PropertyValidation.PropertyFormat ? property.PropertyValidation.PropertyFormat : null" 
          [maxlength]="property.PropertyValidation.PropertyLength == 0 ? null : property.PropertyValidation.PropertyLength" [required]="property.PropertyValidation.IsMandatory">
          <span></span>  <!-- required for validation purpose -->
          <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
            <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
            <div *ngIf="PropertyValue.errors.noMatch">{{property.ParentPropertyName}} does not match</div>
            <div *ngIf="PropertyValue.errors.maxlength"><span [innerHTML]="property.PropertyDisplay"></span> cannot be more than {{ property.PropertyValidation.PropertyLength }}</div>
            <div *ngIf="PropertyValue.errors.pattern">{{ property.PropertyValidation.FormatValidationMessage }}</div>
          </div>
        </div>
        <ng-template #noValidate> 
            <input #textbox type="text" 
            [id]="property.PropertyName"
            [ngClass]="{'form-control': true, 'uppercase': property.PropertyDisplayFormat == 'UPPER'}" 
            [attr.name]="property.PropertyName"
            autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'off'}}"
            [name] = "property.PropertyName"
            [(ngModel)]="property.PropertyValueDisplay" 
            [value]="property.PropertyValueDisplay" 
            (change)="onValueChange(property, textbox.value)">
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'TEXTBOXSUGGEST'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <div *ngIf="property.PropertyValidation; else noValidate" class="property-group">
          <input #textbox type="text" [id]="property.PropertyName" 
            class="form-control typeahead"
            [typeahead]="property.PropertyValueSelection"
            typeaheadOptionField="SelectionDisplay"
            [typeaheadOptionsLimit]="10"
            (typeaheadOnSelect)="onValueChange(property, textbox.value)"
            adaptivePosition="true"
            [name]="property.PropertyName"
            [attr.name]="property.PropertyName"
            autocomplete="off"
            (change)="onValueChange(property, textbox.value, PropertyValue)"
            [(ngModel)]="property.PropertyValueDisplay"
            [value]="property.PropertyValueDisplay"
            #PropertyValue="ngModel"
            [ngModelOptions]="{ updateOn: 'blur' }"
            [pattern]="property.PropertyValidation.PropertyFormat ? property.PropertyValidation.PropertyFormat : null" 
            [maxlength]="property.PropertyValidation.PropertyLength == 0 ? null : property.PropertyValidation.PropertyLength" [required]="property.PropertyValidation.IsMandatory">
            <span></span>  <!-- required for validation purpose -->
            <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
              <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
              <div *ngIf="PropertyValue.errors.noMatch">{{property.ParentPropertyName ? property.ParentPropertyName : property.PropertyName}} does not match</div>
              <div *ngIf="PropertyValue.errors.maxlength"><span [innerHTML]="property.PropertyDisplay"></span> cannot be more than {{ property.PropertyValidation.PropertyLength }}</div>
              <div *ngIf="PropertyValue.errors.pattern">{{ property.PropertyValidation.FormatValidationMessage }}</div>
            </div>
        </div>
        <ng-template #noValidate>
          <input #textbox type="text" 
            [id]="property.PropertyName"
            class="form-control typeahead"
            [typeahead]="property.PropertyValueSelection"
            typeaheadOptionField="SelectionDisplay"
            [typeaheadOptionsLimit]="10"
            (typeaheadOnSelect)="onValueChange(property, textbox.value)"
            adaptivePosition="true"
            [attr.name]="property.PropertyName"
            autocomplete="off"
            [name] = "property.PropertyName"
            [(ngModel)]="property.PropertyValueDisplay" 
            [value]="property.PropertyValueDisplay"
            (change)="onValueChange(property, textbox.value)">
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'TEXTBOXSUGGESTID'">
      <!-- <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <div *ngIf="property.PropertyValidation; else noValidate" class="property-group">
          <input #textbox type="text" [id]="property.PropertyName" 
            class="form-control typeahead"
            [typeahead]="property.PropertyValueSelection"
            typeaheadOptionField="SelectionDisplay"
            [typeaheadOptionsLimit]="10"
            (typeaheadOnSelect)="onTextboxSuggest(property,$event)"
            adaptivePosition="true"
            [name]="property.PropertyName"
            [attr.name]="property.PropertyName"
            autocomplete="off"
            (change)="onValueChange(property, textbox.value, PropertyValue)"
            [(ngModel)]="property.PropertyValueDisplay"
            [value]="property.PropertyValueDisplay"
            #PropertyValue="ngModel"
            [ngModelOptions]="{ updateOn: 'blur' }"
            [pattern]="property.PropertyValidation.PropertyFormat ? property.PropertyValidation.PropertyFormat : null" 
            [maxlength]="property.PropertyValidation.PropertyLength == 0 ? null : property.PropertyValidation.PropertyLength" [required]="property.PropertyValidation.IsMandatory">
            <span></span>  
            <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
              <div *ngIf="PropertyValue.errors.required">{{ property.PropertyDisplay }} is required</div>
              <div *ngIf="PropertyValue.errors.noMatch">{{property.ParentPropertyName}} does not match</div>
              <div *ngIf="PropertyValue.errors.maxlength">{{ property.PropertyDisplay }} cannot be more than {{ property.PropertyValidation.PropertyLength }}</div>
              <div *ngIf="PropertyValue.errors.pattern">{{ property.PropertyValidation.FormatValidationMessage }}</div>
            </div>
        </div>
        <ng-template #noValidate>
          <input #textbox type="text" 
            [id]="property.PropertyName"
            class="form-control typeahead"
            [typeahead]="property.PropertyValueSelection"
            typeaheadOptionField="SelectionDisplay"
            [typeaheadOptionsLimit]="10"
            (typeaheadOnSelect)="onValueChange(property, textbox.value)"
            adaptivePosition="true"
            [attr.name]="property.PropertyName"
            autocomplete="off"
            [name] = "property.PropertyName"
            [(ngModel)]="property.PropertyValueDisplay" 
            [value]="property.PropertyValueDisplay"
            (change)="onValueChange(property, textbox.value)">
        </ng-template>
      </ng-container> -->
      <app-property-summary [suggestSummary]="property" (propertySuggest)="onValueChange(property, $event)" [submitted]="submitted"></app-property-summary>
      <!-- <app-sub-summary [suggestSummary]="property" (propertySuggest)="onValueChange(property, $event)"></app-sub-summary> -->
    </ng-container>
    <ng-container *ngSwitchCase="'PASSWORD'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <div *ngIf="property.PropertyValidation; else noValidate" class="property-group">
          <input #textbox type="password"
          [id]="property.PropertyName"
          [ngClass]="{ 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid }"
          [value]="property.PropertyValue" 
          [name] = "property.PropertyName"
          [(ngModel)]="property.PropertyValue"
          autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'new-password'}}" 
          (change)="onValueChange(property, textbox.value, PropertyValue)"
          #PropertyValue="ngModel"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [pattern]="property.PropertyValidation.PropertyFormat ? property.PropertyValidation.PropertyFormat : null" 
          [maxlength]="property.PropertyValidation.PropertyLength == 0 ? null : property.PropertyValidation.PropertyLength" [required]="property.PropertyValidation.IsMandatory">
          <span></span>  <!-- required for validation purpose -->
          <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
            <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
            <div *ngIf="PropertyValue.errors.noMatch">{{property.ParentPropertyName ? property.ParentPropertyName : property.PropertyName}} does not match</div>
            <div *ngIf="PropertyValue.errors.pattern">{{ property.PropertyValidation.FormatValidationMessage }}</div>
          </div>
        </div>
        <ng-template #noValidate>
            <input #textbox type="password"
            [id]="property.PropertyName" 
            class="form-control" 
            [value]="property.PropertyValue" 
            (change)="onValueChange(property, textbox.value)"
            autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'new-password'}}">
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'SECURETEXTBOX'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <div *ngIf="property.PropertyValidation; else noValidate" class="property-group">
          <input #textbox appBlockCopyPaste type="text"
          [id]="property.PropertyName"
          [allowBlock]="true"
          [ngClass]="{ 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid }"
          [value]="property.PropertyValue" 
          [name] = "property.PropertyName"
          autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'off'}}"
          [(ngModel)]="property.PropertyValue" 
          (change)="onValueChange(property, textbox.value, PropertyValue)"
          #PropertyValue="ngModel"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [pattern]="property.PropertyValidation.PropertyFormat ? property.PropertyValidation.PropertyFormat : null" 
          [maxlength]="property.PropertyValidation.PropertyLength == 0 ? null : property.PropertyValidation.PropertyLength" [required]="property.PropertyValidation.IsMandatory">
          <span></span>  <!-- required for validation purpose -->
          <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
            <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
            <div *ngIf="PropertyValue.errors.noMatch">{{property.ParentPropertyName ? property.ParentPropertyName : property.PropertyName}} does not match</div>
            <div *ngIf="PropertyValue.errors.maxlength"><span [innerHTML]="property.PropertyDisplay"></span> cannot be more than {{ property.PropertyValidation.PropertyLength }}</div>
            <div *ngIf="PropertyValue.errors.pattern">{{ property.PropertyValidation.FormatValidationMessage }}</div>
          </div>
        </div>
        <ng-template #noValidate>
            <input #textbox appBlockCopyPaste type="text"
            [id]="property.PropertyName"
            [allowBlock]="true"
            class="form-control" 
            [value]="property.PropertyValue" 
            (change)="onValueChange(property, textbox.value)"
            autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'off'}}">
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'REFERENCE'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <ng-container *ngIf="!property.PropertyValue; else default">
          <a href="javascript:void(0)" (click)="onValueChange(property);">{{ property.PropertyDisplayFormat }}</a></ng-container>
        <ng-template #default>
          <a href="javascript:void(0)" (click)="onValueChange(property);">{{ property.PropertyValueDisplay }}</a>
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'TEXTAREA'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <ng-container *ngIf="property.PropertyValidation; else noValidate" class="property-group">
          <textarea #textarea
            [id]="property.PropertyName"
            type="text" 
            [ngClass]="{ 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid }" 
            [value]="property.PropertyValueDisplay" 
            [name] = "property.PropertyName"
            [attr.autocomplete]="property.IsAutoComplete ? property.PropertyName : 'off'"
            [(ngModel)]="property.PropertyValue" 
            (change)="onValueChange(property, textarea.value, PropertyValue)"
            #PropertyValue="ngModel"
            [ngModelOptions]="{ updateOn: 'blur' }"
            [pattern]="property.PropertyValidation.PropertyFormat ? property.PropertyValidation.PropertyFormat : null" 
            [maxlength]="property.PropertyValidation.PropertyLength == 0 ? null : property.PropertyValidation.PropertyLength" [required]="property.PropertyValidation.IsMandatory">
          </textarea>
          <span></span>
          <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
            <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
            <div *ngIf="PropertyValue.errors.maxlength"><span [innerHTML]="property.PropertyDisplay"></span> cannot be more than {{ property.PropertyValidation.PropertyLength }}</div>
            <div *ngIf="PropertyValue.errors.pattern">{{ property.PropertyValidation.FormatValidationMessage }}</div>
          </div>
        </ng-container>
        <ng-template #noValidate>
            <textarea #textarea type="text" [id]="property.PropertyName" class="form-control" [value]="property.PropertyValue" [attr.autocomplete]="property.IsAutoComplete ? property.PropertyName : 'off'"
            (change)="onValueChange(property, textarea.value)"></textarea>
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'CREATEDATE'">
      <span [innerHTML]="property.PropertyValueDisplay" [id]="property.PropertyName" class="display-prop"></span>
    </ng-container>
    <ng-container *ngSwitchCase="'UPDATEDATE'">
      <span [innerHTML]="property.PropertyValueDisplay" [id]="property.PropertyName" class="display-prop"></span>
    </ng-container>
    <ng-container *ngSwitchCase="'CREATEBY'">
      <span [innerHTML]="property.PropertyValueDisplay" [id]="property.PropertyName" class="display-prop"></span>
    </ng-container>
    <ng-container *ngSwitchCase="'UPDATEBY'">
      <span [innerHTML]="property.PropertyValueDisplay" [id]="property.PropertyName" class="display-prop"></span>
    </ng-container>
    <ng-container *ngSwitchCase="'LABEL'">
      <span [innerHTML]="property.PropertyValueDisplay" [id]="property.PropertyName" class="display-prop"></span>
    </ng-container>
    <ng-container *ngSwitchCase="'CHECKBOX'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <!-- use mat radio group as a replacement for mat checkbox group as checkbox group not supported as of now,
        this is to let required property validate at least one selection -->
        <mat-radio-group [id]="property.PropertyName" 
          [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory :null : null" 
          [(ngModel)]="property.PropertyValueArray"
          #PropertyValue="ngModel"
          [name]="property.PropertyName"> 
          <div *ngFor="let val of property.PropertyValueSelection; let i=index" class="mat-checkbox-container">
            <mat-checkbox matCheckbox #matCheckbox="matCheckbox"
            [attr.name]="property.PropertyName"
            (change)="onValueChange(property, $event)" 
            [value]="val.SelectionValue" 
            [checked]="val.IsSelected == true">{{ val.SelectionDisplay }}</mat-checkbox>
          </div>
        </mat-radio-group>
        <ng-container *ngIf="PropertyValue">
          <div *ngIf="PropertyValue.invalid" class="invalid-feedback" [ngStyle]="{'display': submitted ? 'block' : 'none'}">
            <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'RADIOBUTTON'">
      <ng-container *ngIf="property.PropertyIsEditable== true;else isDisplay">
        <!-- <fieldset [id]="property.PropertyName">
          <div *ngFor="let value of property.PropertyValueSelection;let i=index" [ngClass]="{'mb-rb-container': group.GroupFormat == 'STACKED'}">
            <label style="margin-right: 10px;float: left;" class="radio-btn">
                {{ value.SelectionDisplay }}
              <input #radiobtn 
              id="{{property.PropertyName}}{{i}}"
              type="radio"
              [name]="property.PropertyName"
              class="custom-radio-btn" 
              [ngClass]="{ 'custom-radio-btn':true, 'is-invalid': submitted && PropertyValue.invalid }"
              [value]="value.SelectionValue" 
              [checked]="value.IsSelected == true" 
              (change)="onValueChange(property, value.SelectionValue)"
              [(ngModel)]="property.PropertyValue"
              [name]="property.PropertyName"
              #PropertyValue="ngModel"
              [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory :null : null">
              <span class="checkmark"></span>
            </label>
            <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
              <div *ngIf="PropertyValue.errors.required">{{ property.PropertyDisplay }} is required</div>
            </div>
          </div>
        </fieldset> -->
        <mat-radio-group [id]="property.PropertyName" [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory :null : null" 
        [(ngModel)]="property.PropertyValue"
        #PropertyValue="ngModel"
        [name]="property.PropertyName">
          <mat-radio-button matRadioButton #matRadio="matRadioButton" *ngFor="let value of property.PropertyValueSelection;let i=index"
          id="{{property.PropertyName}}{{i}}"
          [value]="value.SelectionValue"
          (change)="onValueChange(property, value.SelectionValue)"
          [name]="property.PropertyName"
          [checked]="value.SelectionValue == property.PropertyValue"
          [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory :null : null">
            {{value.SelectionDisplay}}
          </mat-radio-button>
        </mat-radio-group>
        <ng-container *ngIf="PropertyValue">
          <div *ngIf="PropertyValue.invalid" class="invalid-feedback" [ngStyle]="{'display': submitted && !property.PropertyValue ? 'block' : 'none'}">
            <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'DATE'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <!--<input *ngIf="!property.IsAutoComplete" [attr.name]="property.PropertyName" hidden>-->
        <div #dateInput *ngIf="property.PropertyValidation; else noValidate" class="input-group date-group">
          <input #textbox [ngClass]="{'form-control date-input': true, 'is-invalid': submitted && PropertyValueDisplay.invalid }" [matDatepicker]="picker"
          [id]="property.PropertyName"
          type="text"
          [value]="dateValue"
          [(ngModel)]="dateValue"
          placeholder="Select Date - Format : {{property.PropertyDisplayFormat}}"
          (dateChange)="onValueChange(property, textbox.value, PropertyValueDisplay)"
          [name]="property.PropertyName"
          [min]="dateMin" [max]="dateMax"
          autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'off'}}"
          #PropertyValueDisplay="ngModel"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [required]="property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory : null">
           <span></span> <!-- required for validation purpose -->
          <mat-datepicker #picker></mat-datepicker>
          <div class="input-group-append date-group" (click)="picker.open()" tabindex="0" (keyup.enter)="picker.open()">
            <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-calendar"></i></span>
          </div>
          <div *ngIf="PropertyValueDisplay.invalid" class="invalid-feedback">
            <div *ngIf="!property.PropertyValidation.InvalidFormat && (PropertyValueDisplay.errors.required || PropertyValueDisplay.errors.matDatepickerParse); else invalidformat">
                <span [innerHTML]="property.PropertyDisplay"></span> is required
            </div>
            <ng-template #invalidformat>
              <div *ngIf="(PropertyValueDisplay.errors.matDatepickerMin || PropertyValueDisplay.errors.DateMin) && property.PropertyValidation.MinValue == '@CURRENTDATETIME'; else min">
                <span [innerHTML]="property.PropertyDisplay"></span> cannot be before current date time
              </div>
              <div *ngIf="property.PropertyValidation.InvalidFormat">{{ property.PropertyValidation.FormatValidationMessage }}</div>
            </ng-template>
          </div>
        </div>
        <ng-template #noValidate>
          <div #dateInput class='input-group'>
            <input #textbox class="form-control date-input" [matDatepicker]="picker"
            [id]="property.PropertyName"
            [value]="dateValue"
            [(ngModel)]="dateValue"
            [name]="property.PropertyName"
            autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'off'}}"
            placeholder="Select Date - Format : {{property.PropertyDisplayFormat}}"
            (dateChange)="onValueChange(property, textbox.value)"
            [ngModelOptions]="{ updateOn: 'blur' }">
            <mat-datepicker #picker></mat-datepicker>
            <div class="input-group-append date-group" (click)="picker.open()" tabindex="0" (keyup.enter)="picker.open()">
              <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-calendar"></i></span>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'DATETIME'">
        <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
          <!--<input *ngIf="!property.IsAutoComplete" [attr.name]="property.PropertyName" hidden>-->
          <div #dateInput *ngIf="property.PropertyValidation; else noValidate" class="input-group date-time-group">
            <input #textbox [ngClass]="{'form-control date-input': true, 'is-invalid': submitted && PropertyValueDisplay.invalid }" [matDatepicker]="picker"
            [id]="property.PropertyName + 'date'"
            type="text"
            [(ngModel)]="dateValue"
            placeholder="Format : {{property.PropertyDisplayFormat}}"
            (dateChange)="onDateTimeChange(textbox.value, $event, PropertyValueDisplay, property)"
            [name]="property.PropertyName"
            autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'off'}}"
            #PropertyValueDisplay="ngModel"
            [min]="dateMin" [max]="dateMax"
            [ngModelOptions]="{ updateOn: 'blur' }"
            [required]="property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory : null">
              <span></span><!-- required for validation purpose -->
            <mat-datepicker #picker></mat-datepicker>
            <div class="input-group-append" (click)="picker.open()" tabindex="0" (keyup.enter)="picker.open()">
              <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-calendar"></i></span>
            </div>
            <!-- <span (click)="show(PropertyValueDisplay)">{{dateValue}}</span> -->
            <div *ngIf="PropertyValueDisplay.invalid" class="invalid-feedback">
              <div *ngIf="!property.PropertyValidation.InvalidFormat && PropertyValueDisplay.errors.required; else invalidformat">
                <span [innerHTML]="property.PropertyDisplay"></span> is required
              </div>
              <ng-template #invalidformat>
                <div *ngIf="property.PropertyValidation.InvalidFormat || PropertyValueDisplay.errors.matDatepickerParse; else minMax">{{ property.PropertyValidation.FormatValidationMessage }}</div>

                <ng-template #minMax>
                  <div *ngIf="(PropertyValueDisplay.errors.matDatepickerMin || PropertyValueDisplay.errors.DateMin) && property.PropertyValidation.MinValue == '@CURRENTDATETIME'; else min">
                      <span [innerHTML]="property.PropertyDisplay"></span> cannot be before current date time
                  </div>
                  <ng-template #min>
                    <div *ngIf="PropertyValueDisplay.errors.matDatepickerMin"><span [innerHTML]="property.PropertyDisplay"></span> cannot be before than {{property.PropertyValidation.MinValue}}</div>
                    <div *ngIf="!PropertyValueDisplay.errors.matDatepickerMin && PropertyValueDisplay.errors.DateMin">
                      <span [innerHTML]="property.PropertyDisplay"></span> cannot be before than {{property.PropertyValidation.MinValue}}
                    </div>
                  </ng-template>
                  <div *ngIf="PropertyValueDisplay.errors.matDatepickerMax"><span [innerHTML]="property.PropertyDisplay"></span> cannot be greater than {{property.PropertyValidation.MaxValue}}</div>
                </ng-template>
              </ng-template>

            </div>

          </div>
          <ng-template #noValidate>
            <div #dateInput class='input-group date-time-group'>
              <input #textbox class="form-control date-input" [matDatepicker]="picker"
              [id]="property.PropertyName"
              [value]="dateValue"
              [(ngModel)]="dateValue"
              [name]="property.PropertyName"
              autocomplete="{{property.IsAutoComplete ? property.PropertyName : 'off'}}"
              placeholder="Select Date"
              (dateChange)="onDateTimeChange(textbox.value, $event)">
              <mat-datepicker #picker></mat-datepicker>
              <div class="input-group-append" (click)="picker.open()" tabindex="0" (keyup.enter)="picker.open()">
                <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-calendar"></i></span>
              </div>
            </div>
          </ng-template>
          <div class="input-group time-picker">
            <!-- <input #timepicker
            [id]="property.PropertyName + 'time'"
            type="time"
            [value]="timeValue" 
            [name]="property.PropertyName" 
            placeholder="Select Time" 
            class="form-control time-input"
            (change)="onTimeChange(timepicker.value, property)"/> -->
            <!-- <mat-form-field appearance="outline"> -->
              <!-- <div class="time-test">
                <input #hour class="hour" size="3" (input)="_handleInput(hour.value)">
                <span class="time-spacer">:</span>
                <input #minute class="minute" (input)="_handleInput(minute.value)">
                <span class="time-spacer">:</span>
                <input #timeformat class="format" (input)="_handleInput(timeformat.value)">
              </div> -->
            <!-- </mat-form-field> -->
            <!-- <div class="input-group-append date-group" (click)="openTimePicker(property)" tabindex="0" (keyup.enter)="openTimePicker(property)">
              <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-clock-o"></i></span>
            </div> -->
          </div>
          <div class="input-group time-picker">
            <div class="timepicker-field">
              <ngx-timepicker-field #timepicker [toggleIcon]="icon" [clockTheme]="darkTheme" [format]="format24h ? 24 : 12" [defaultTime]="defaultTime" 
              (ngInit)="afterInit()" [isLast]='true'></ngx-timepicker-field>
              <ng-template #icon>
                <div class="input-group-append date-group" tabindex="0">
                  <span class="input-group-text time-icon">
                    <i class="fa fa-clock-o"></i></span>
                </div>
              </ng-template>
            </div>
          </div> 
        </ng-container>
      </ng-container>
    <ng-container *ngSwitchCase="'COMBOBOX'">
      <!-- new stuff -->
      <!-- <ng-select [items]="[]"
          [id]="property.PropertyName"
          class="multitext"
          (click)="onClickCombobox(property)" 
          [addTag]="true"
          (change)="onValueChange(property, $event)"
          [(ngModel)]="property.PropertyValueDisplayArray"
          [name]="property.PropertyName"
          multiple="true"
          [isOpen]="false"
          (paste)="onPaste(property, $event)">
        </ng-select> -->
        <!-- new stuff -->
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <ng-container *ngIf="property.PropertyValidation; else noValidate">
          <ng-select #select [items]="property.PropertyValueSelection"
            [id]="property.PropertyName"
            [ngClass]="{ 'detail-dropdown': true, 'is-invalid': submitted && PropertyValueDisplay.invalid, 'loading': retrievingLookupList, 'disabled': property.isDisabled }" 
            (click)="onClickCombobox(property, true); select.focus()"
            (close)="onCloseCombobox()"
            (blur)="onBlur(property)"
            appendTo="{{ isPopupDetail ? 'body' : 'body' }}"
            (change)="onValueChange(property, $event.SelectionMapValue, PropertyValueDisplay)"
            (keyup)="search(property, $event)"
            [clearable]="false" 
            [searchable]="true"
            [title]="property.PropertyValueDisplay"
            [isOpen]="property.IsDropdownOpen"
            bindLabel="SelectionDisplay"
            bindValue="SelectionValue"
            placeholder="Select {{property.PropertyDisplay}}"
            [(ngModel)]="property.PropertyValue"
            [name]="property.PropertyName"
            #PropertyValueDisplay="ngModel"
            [ngModelOptions]="{ updateOn: 'blur' }" 
            [compareWith]="compareFn"
            [required]="property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory : null">
            <ng-template *ngIf="retrievingLookupList" ng-header-tmp>
              <span class="loading-dropdown" title="loading dropdown list.." style="padding-left: 20px;">Loading dropdown list..</span>
            </ng-template>
          </ng-select>
          <div *ngIf="PropertyValueDisplay.invalid" class="invalid-feedback">
            <div *ngIf="PropertyValueDisplay.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
            <div *ngIf="PropertyValueDisplay.errors.pattern">{{ property.PropertyValidation.FormatValidationMessage }}</div>
          </div>
        </ng-container>
        <ng-template #noValidate>
            <ng-select #select [items]="property.PropertyValueSelection"
            [id]="property.PropertyName"
            [ngClass]="{'detail-dropdown': true, 'loading': retrievingLookupList, 'loading': retrievingLookupList, 'disabled': property.isDisabled}"
            (click)="onClickCombobox(property, true); select.focus()"
            (close)="onCloseCombobox()"
            (blur)="onBlur(property)"
            appendTo="{{ isPopupDetail ? 'body' : 'body' }}"
            (change)="onValueChange(property, $event.SelectionMapValue)"
            (keyup)="search(property, $event)"
            [isOpen]="property.IsDropdownOpen"
            [clearable]="false" 
            [title]="property.PropertyValueDisplay"
            [searchable]="true"
            bindLabel="SelectionDisplay"
            bindValue="SelectionValue"
            placeholder="Select {{property.PropertyDisplay}}"
            value="property.PropertyValue"
            [(ngModel)]="property.PropertyValue"
            [name]="property.PropertyName"
            [compareWith]="compareFn">
            <ng-template *ngIf="retrievingLookupList" ng-header-tmp>
              <span class="loading-dropdown" title="loading dropdown list.." style="padding-left: 20px;">Loading dropdown list..</span>
            </ng-template>
          </ng-select>
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'MULTICOMBOBOX'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <ng-container *ngIf="property.PropertyValidation; else noValidate">
          <ng-select #select
          [items]="property.PropertyValueSelection"
          [id]="property.PropertyName"
          bindLabel="SelectionDisplay"
          bindValue="SelectionValue"
          [ngClass]="{ 'detail-dropdown': true, 'multi': true, 'is-invalid': submitted && PropertyValueArray.invalid, 'loading': retrievingLookupList }" 
          (click)="onClickCombobox(property); select.focus()"
          (close)="onCloseCombobox()"
          (blur)="onBlur(property)"
          [isOpen]="property.IsDropdownOpen"
          appendTo="{{ isPopupDetail ? 'body' : 'body' }}"
          (change)="onValueChange(property, $event, PropertyValueArray)"
          (keyup)="search(property, $event)"
          [clearable]="true"
          [closeOnSelect]="false" 
          [searchable]="true"
          [multiple] = "true"
          placeholder="Select {{property.PropertyDisplay}}"
          [(ngModel)]="property.PropertyValueArray"
          [name]="property.PropertyName"
          #PropertyValueArray="ngModel"
          [compareWith]="compareFn"
          [required]="property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory : null">
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
                <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                <span class="ng-value-label">{{item.SelectionDisplay}}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 10">
                <span class="ng-value-label">{{items.length - 10}} more...</span>
            </div>
          </ng-template>
          </ng-select>
          <div *ngIf="PropertyValueArray.invalid" class="invalid-feedback">
            <div *ngIf="PropertyValueArray.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
            <div *ngIf="PropertyValueArray.errors.pattern">{{ property.PropertyValidation.FormatValidationMessage }}</div>
          </div>
        </ng-container>
        <ng-template #noValidate>
          <ng-select #select
          [items]="property.PropertyValueSelection"
          [id]="property.PropertyName"
          [ngClass]="{'detail-dropdown': true, 'multi': true, 'loading': retrievingLookupList}"
          bindLabel="SelectionDisplay"
          bindValue="SelectionValue"
          (click)="onClickCombobox(property); select.focus()"
          (close)="onCloseCombobox()"
          (blur)="onBlur(property)"
          [isOpen]="property.IsDropdownOpen"
          appendTo="{{ isPopupDetail ? 'body' : 'body' }}"
          (change)="onValueChange(property, $event)"
          (keyup)="search(property, $event)"
          [clearable]="true"
          [closeOnSelect]="false" 
          [searchable]="true"
          [multiple] = "true"
          placeholder="Select {{property.PropertyDisplay}}"
          [(ngModel)]="property.PropertyValueArray"
          [name]="property.PropertyName"
          [compareWith]="compareFn">
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label">{{item.SelectionDisplay}}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 10">
              <span class="ng-value-label">{{items.length - 10}} more...</span>
            </div>
          </ng-template>
          </ng-select>
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'HIERARCHYSINGLESELECT'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <ng-container *ngIf="property.PropertyValidation; else noValidate">
          <ng-select #select
          [items]="property.PropertyValueSelection"
          [id]="property.PropertyName"
          bindLabel="SelectionDisplay"
          bindValue="SelectionValue"
          [ngClass]="{ 'hierarchy-dropdown':true, 'is-invalid': submitted && PropertyValueArray.invalid, 'loading': property.PropertyLoadHierarchy }" 
          (open)="onClickCombobox(property)"
          (close)="onCloseCombobox()"
          [isOpen]="false"
          (change)="onValueChange(property, $event, PropertyValueArray)"
          [searchable]="false"
          [clearable]="true"
          [closeOnSelect]="false"
          [multiple] = "true"
          placeholder="Select {{property.PropertyDisplay}}"
          [(ngModel)]="property.PropertyValueArray"
          [name]="property.PropertyName"
          #PropertyValueArray="ngModel"
          [compareWith]="compareFn"
          [required]="property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory : null">
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label">{{item.SelectionDisplay}}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 10">
              <span class="ng-value-label">{{items.length - 10}} more...</span>
            </div>
          </ng-template>
          </ng-select>
          <input tabindex="0" type="button" class="btn btn-primary browse-hierarchy" [id]="'Browse ' + property.PropertyName" value="Browse" (keyup.enter)="toggleHierarchy(property)" (click)="toggleHierarchy(property)" [disabled]="property.PropertyLoadHierarchy"/>
          <div class="clearfix"></div>
          <div *ngIf="PropertyValueArray.invalid" class="invalid-feedback">
            <div *ngIf="PropertyValueArray.errors.required">{{ property.PropertyDisplay }} is required</div>
          </div>
        </ng-container>
        <ng-template #noValidate>
          <ng-select #select
          [ngClass]="{'hierarchy-dropdown': true, 'loading': property.PropertyLoadHierarchy }"
          [items]="property.PropertyValueSelection"
          [id]="property.PropertyName"
          bindLabel="SelectionDisplay"
          bindValue="SelectionValue"
          (open)="onClickCombobox(property)"
          (close)="onCloseCombobox()"
          [isOpen]="false"
          (change)="onValueChange(property, $event)"
          [searchable]="false"
          [clearable]="true"
          [closeOnSelect]="false"
          [multiple] = "true"
          placeholder="Select {{property.PropertyDisplay}}"
          [(ngModel)]="property.PropertyValueArray"
          [name]="property.PropertyName"
          [compareWith]="compareFn">
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label">{{item.SelectionDisplay}}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 10">
              <span class="ng-value-label">{{items.length - 10}} more...</span>
            </div>
          </ng-template>
          </ng-select>
          <input tabindex="0" type="button" class="btn btn-primary browse-hierarchy" [id]="'Browse ' + property.PropertyName" value="Browse" (keyup.enter)="toggleHierarchy(property)" (click)="toggleHierarchy(property)" [disabled]="property.PropertyLoadHierarchy"/>
          <div class="clearfix"></div>
        </ng-template>
        <!-- <div class="hierarchy-view-container" [hidden]="!property.PropertyShowHierarchy">
          <app-hierarchy-view [treeControl]="treeControl" [treeDataSource]="treeDataSource" [hasChildren]="hasChildren" (selectTree)="selectTree($event)" [selectItem]="selectedItemId"></app-hierarchy-view>
        </div> -->
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'HIERARCHYMULTISELECT'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <ng-container *ngIf="property.PropertyValidation; else noValidate">
          <ng-select #select
          [items]="property.PropertyValueSelection"
          [id]="property.PropertyName"
          bindLabel="SelectionDisplay"
          bindValue="SelectionValue"
          [ngClass]="{ 'hierarchy-dropdown':true, 'is-invalid': submitted && PropertyValueArray.invalid, 'loading': property.PropertyLoadHierarchy  }" 
          (open)="onClickCombobox(property)"
          (close)="onCloseCombobox()"
          [isOpen]="false"
          (change)="onValueChange(property, $event, PropertyValueArray)"
          [searchable]="false"
          [clearable]="true"
          [closeOnSelect]="false"
          [multiple] = "true"
          placeholder="Select {{property.PropertyDisplay}}"
          [(ngModel)]="property.PropertyValueArray"
          [name]="property.PropertyName"
          #PropertyValueArray="ngModel"
          [ngModelOptions]="{ updateOn: 'blur' }"
          [compareWith]="compareFn"
          [required]="property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory : null">
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label">{{item.SelectionDisplay}}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 10">
              <span class="ng-value-label">{{items.length - 10}} more...</span>
            </div>
          </ng-template>
          </ng-select>
          <input tabindex="0" type="button" class="btn btn-primary browse-hierarchy" [id]="'Browse ' + property.PropertyName" value="Browse" (keyup.enter)="toggleHierarchy(property)" (click)="toggleHierarchy(property)" [disabled]="property.PropertyLoadHierarchy"/>
          <div class="clearfix"></div>
          <div *ngIf="PropertyValueArray.invalid" class="invalid-feedback">
            <div *ngIf="PropertyValueArray.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
          </div>
        </ng-container>
        <ng-template #noValidate>
          <ng-select #select
          [ngClass]="{'hierarchy-dropdown': true, 'loading': property.PropertyLoadHierarchy }"
          [items]="property.PropertyValueSelection"
          [id]="property.PropertyName"
          bindLabel="SelectionDisplay"
          bindValue="SelectionValue"
          (open)="onClickCombobox(property)"
          (close)="onCloseCombobox()"
          [isOpen]="false"
          (change)="onValueChange(property, $event)"
          [searchable]="false"
          [clearable]="true"
          [closeOnSelect]="false"
          [multiple] = "true"
          placeholder="Select {{property.PropertyDisplay}}"
          [(ngModel)]="property.PropertyValueArray"
          [name]="property.PropertyName"
          [compareWith]="compareFn">
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
              <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
              <span class="ng-value-label">{{item.SelectionDisplay}}</span>
            </div>
            <div class="ng-value" *ngIf="items.length > 10">
              <span class="ng-value-label">{{items.length - 10}} more...</span>
            </div>
          </ng-template>
          </ng-select>
          <input tabindex="0" type="button" class="btn btn-primary browse-hierarchy" [id]="'Browse ' + property.PropertyName" value="Browse" (keyup.enter)="toggleHierarchy(property)" (click)="toggleHierarchy(property)" [disabled]="property.PropertyLoadHierarchy"/>
          <div class="clearfix"></div>
        </ng-template>
        <!-- <div class="hierarchy-view-container" [hidden]="!property.PropertyShowHierarchy">
          <app-hierarchy-view [treeControl]="treeControl" [treeDataSource]="treeDataSource" [hasChildren]="hasChildren" (selectTree)="selectTree($event)" [selectItem]="selectedItemId"></app-hierarchy-view>
        </div> -->
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'GROUPCHECKBOX'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <ng-container *ngIf="property.PropertyValidation; else noValidate">
          <!-- <ng-select #select
            [items]="property.PropertyValueSelection"
            bindLabel="SelectionDisplay"
            bindValue="SelectionValue"
            [ngClass]="{ 'group-checkbox': true, 'is-invalid': submitted && PropertyValueArray.invalid, 'loading': retrievingLookupList }" 
            (click)="onClickCombobox(property)" 
            (change)="onValueChange(property, $event, false, true)"
            [clearable]="true"
            groupBy="GroupBy"
            [closeOnSelect]="false" 
            [selectableGroup]="true"
            [searchable]="true"
            [multiple] = "true"
            placeholder="Select {{property.PropertyDisplay}}"
            [(ngModel)]="property.PropertyValueArray"
            [name]="property.PropertyName"
            #PropertyValueArray="ngModel"
            [ngModelOptions]="{ updateOn: 'blur' }"
            [pattern]="property.PropertyValidation.PropertyFormat ? property.PropertyValidation.PropertyFormat : null" 
            [maxlength]="property.PropertyValidation.PropertyLength == 0 ? null : property.PropertyValidation.PropertyLength" [required]="property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory : null">
            <ng-template *ngIf="retrievingLookupList" ng-header-tmp>
              <span class="loading-dropdown" title="loading dropdown list.." style="padding-left: 20px;">Loading dropdown list..</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
              <span class="opt-group-expand" (click)="star($event, item$)"></span>
              <input id="item-{{index}}" type="checkbox" name="item-{{index}}" [ngModel]="item$.selected"/> {{item.GroupBy | uppercase}}
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input id="item-{{index}}" type="checkbox" name="item-{{index}}" [ngModel]="item$.selected" [value]="item.SelectionValue"/> {{item.SelectionDisplay}}
            </ng-template>
          </ng-select> -->
          <div class="flex-group" style="flex-direction: row;flex-wrap: wrap;">
            <ng-select [items]="property.PropertyValueSelection"
              [id]="property.PropertyName"
              bindLabel="SelectionDisplay"
              bindValue="SelectionValue"
              [ngClass]="{'detail-dropdown multitext-checkbox ': true,'is-invalid': submitted && PropertyValueArray.invalid, 'ng-select-focused': showCheckbox, 'ng-select-opened': showCheckbox}"
              multiple="true"
              [isOpen]="false"
              [searchable]="true"
              placeholder="Browse {{property.PropertyDisplay}}"
              (click)="onClickCombobox(property, false, $event)"
              (change)="onGroupCheckboxChange($event, PropertyValueArray)"
              (search)="onSearch($event)"
              [clearOnBackspace]="false"
              [(ngModel)]="property.PropertyValueArray"
              [name]="property.PropertyName"
              #PropertyValueArray="ngModel"
              [ngModelOptions]="{ updateOn: 'blur' }"
              [required]="property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory : null">
              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
                  <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  <span class="ng-value-label">{{item.SelectionDisplay}}</span>
                </div>
                <div class="ng-value" *ngIf="items.length > 10">
                  <span class="ng-value-label">{{items.length - 10}} more...</span>
                </div>
              </ng-template>
            </ng-select>
            <!-- <input type="button" class="btn btn-primary browse-checkbox" value="Browse" (click)="onClickCombobox(property)"/> -->
            <div *ngIf="PropertyValueArray.invalid" class="invalid-feedback" style="flex: 0 1 100%;">
              <div *ngIf="PropertyValueArray.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
            </div>
          </div>
          <!-- list of checkboxes, 2nd design -->
          <div #cb *ngIf="showCheckbox" class="cb-container" id="cb-container">
            <!-- <button type="button" class="close close-checkbox" (click)="closeCheckbox($event)" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button> -->
            <div *ngIf="groupCheckbox.length == 0 && !retrievingLookupList" style="font-style: italic">No record found</div>
            <!-- <div *ngIf="groupCheckbox.length > 0" style="position:absolute;right: 15px;top: 15px;z-index: 9999;">
              <button class="btn btn-primary btn-clear" (click)="clearAll()">Clear All</button>
            </div> -->
            <span *ngIf="retrievingLookupList" class="loading-dropdown" title="loading dropdown list.." style="padding-left: 20px;">Loading list..</span>
            <div class="cb-items-container">
              <div *ngFor="let obj of groupCheckbox" style="margin-bottom:5px;">
                <div *ngIf="obj.key" class="cb-parent">
                  <label class="checkbox-container" [title]="obj.key['name']"> {{ obj.key['name']}}
                    <input type="checkbox" (change)="addToPropArray($event, obj.value, true, obj.key); obj.key['isSelected']=!obj.key['isSelected']" [name]="property.PropertyName" [checked]="obj.key['isSelected']">
                    <span class="checkmark-custom"></span>
                  </label>
                </div>
                <div *ngFor="let value of obj.value" class="checkbox-group">
                  <label class="checkbox-container" style="font-weight: 400;" [title]="value.SelectionDisplay"> {{ value.SelectionDisplay }}
                    <input type="checkbox" (change)="addToPropArray($event, value)" [name]="property.PropertyName" [checked]="value.IsSelected == true">
                    <span class="checkmark-custom"></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </ng-container>
        <ng-template #noValidate>
          <div class="flex-group">
            <ng-select [items]="property.PropertyValueSelection"
              [id]="property.PropertyName"
              bindLabel="SelectionDisplay"
              bindValue="SelectionValue"
              [ngClass]="{'multitext multitext-checkbox': true, 'ng-select-focused': showCheckbox, 'ng-select-opened': showCheckbox}"
              multiple="true"
              [isOpen]="false"
              [searchable]="true"
              [clearOnBackspace]="false"
              (search)="onSearch($event)"
              placeholder="Browse {{property.PropertyDisplay}}"
              (click)="onClickCombobox(property, false, $event)"
              (change)="onGroupCheckboxChange($event)"
              [(ngModel)]="property.PropertyValueArray"
              [name]="property.PropertyName">
            </ng-select>
            <!-- <input type="button" class="btn btn-primary browse-checkbox" value="Browse" (click)="onClickCombobox(property)"/> -->
          </div>
          <!-- list of checkboxes, 2nd design -->
          <div #cb *ngIf="showCheckbox" class="cb-container">
            <!-- <button type="button" class="close close-checkbox" (click)="closeCheckbox($event)" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button> -->
            <div *ngIf="groupCheckbox.length == 0 && !retrievingLookupList" style="font-style: italic">No record found</div>
            <!-- <div *ngIf="groupCheckbox.length > 0" style="position:absolute;right: 15px;top: 15px;z-index: 9999;">
              <button class="btn btn-primary btn-clear" (click)="clearAll()">Clear All</button>
            </div> -->
            <span *ngIf="retrievingLookupList" class="loading-dropdown" title="loading dropdown list.." style="padding-left: 20px;">Loading list..</span>
            <div class="cb-items-container">
              <div *ngFor="let obj of groupCheckbox" style="margin-bottom:5px;">
                <div *ngIf="obj.key" class="cb-parent">
                  <label class="checkbox-container" [title]="obj.key['name']"> {{ obj.key['name']}}
                    <input type="checkbox" (change)="addToPropArray($event, obj.value, true, obj.key); obj.key['isSelected']=!obj.key['isSelected']" [name]="property.PropertyName" [checked]="obj.key['isSelected']">
                    <span class="checkmark-custom"></span>
                  </label>
                </div>
                <div *ngFor="let value of obj.value" class="checkbox-group">
                  <label class="checkbox-container" style="font-weight: 400;" [title]="value.SelectionDisplay"> {{ value.SelectionDisplay }}
                    <input type="checkbox" (change)="addToPropArray($event, value)" [name]="property.PropertyName" [checked]="value.IsSelected == true">
                    <span class="checkmark-custom"></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'MULTITEXT'">
      <ng-container *ngIf="property.PropertyIsEditable == true;else isDisplay">
        <ng-select [items]="[]"
          [id]="property.PropertyName"
          class="multitext"
          (click)="onClickCombobox(property)" 
          [addTag]="true"
          (change)="onValueChange(property, $event)"
          [(ngModel)]="property.PropertyValueDisplayArray"
          [name]="property.PropertyName"
          multiple="true"
          [isOpen]="false"
          (paste)="onPaste(property, $event)">
        </ng-select>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'OPTIONALFILE'">
      <div [id]="property.PropertyName" class="file-container">
          <input #fileInput style="display:none" [name]="property.PropertyName" [value]="property.PropertyValue" [(ngModel)]="property.PropertyValue" #PropertyValue="ngModel"
          [ngClass]="{ 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid}"
          [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? noValidate ? null : property.PropertyValidation.IsMandatory :null : null">

        <app-attachment [attachmentIsMultiple]="false" 
        [setProperty]="property"
        [setComponentId]="componentId"
        (attachments)="setAttachmentValue($event)"
        [setInvalid]="submitted && PropertyValue.invalid"
        (optionalChanged)="optionalChanged($event);"></app-attachment>

        <span></span>  <!-- required for validation purpose -->
        <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
          <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'OPTIONALMULTIPLEFILES'">
      <div [id]="property.PropertyName" class="file-container">
        <input #fileInput style="display:none" [name]="property.PropertyName" [value]="property.PropertyValue" [(ngModel)]="property.PropertyValue" #PropertyValue="ngModel"
        [ngClass]="{ 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid}"
        [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? noValidate ? null : property.PropertyValidation.IsMandatory :null : null">

        <app-attachment [attachmentIsMultiple]="true" 
        [setProperty]="property"
        [setComponentId]="componentId"
        (attachments)="setAttachmentValue($event)"
        [setInvalid]="submitted && PropertyValue.invalid"
        (optionalChanged)="optionalChanged($event)"></app-attachment>

        <span></span>  <!-- required for validation purpose -->
        <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
          <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'FILE'">
      <div [id]="property.PropertyName">
        <input #fileInput style="display:none" [name]="property.PropertyName" [value]="property.PropertyValue" [(ngModel)]="property.PropertyValue" #PropertyValue="ngModel"
        [ngClass]="{ 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid}"
        [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory :null : null">
        
        <app-attachment [attachmentIsMultiple]="false" 
        [setProperty]="property"
        [setComponentId]="componentId"
        (attachments)="property.PropertyValue = $event"
        [setInvalid]="submitted && PropertyValue.invalid"></app-attachment>

        <span></span>  <!-- required for validation purpose -->
        <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
          <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'MULTIPLEFILES'">
      <div [id]="property.PropertyName">
        <input #fileInput style="display:none" [name]="property.PropertyName" [value]="property.PropertyValue" [(ngModel)]="property.PropertyValue" #PropertyValue="ngModel"
        [ngClass]="{ 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid}"
        [required]="property.PropertyValidation ? property.PropertyValidation.IsMandatory ? property.PropertyValidation.IsMandatory :null : null">

        <app-attachment [attachmentIsMultiple]="true" 
        [setProperty]="property"
        [setComponentId]="componentId"
        (attachments)="property.PropertyValue = $event"
        [setInvalid]="submitted && PropertyValue.invalid"></app-attachment>

        <span></span>  <!-- required for validation purpose -->
        <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
          <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="property.PropertyDisplay"></span> is required</div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'FIXEDFILE'">
      <ng-container *ngFor="let prop of property.PropertyDisplayFormat.split(',');index as i; let last= last">
        <a class="fixed-file" [href]="property.PropertyFixedFileUrl[i]"
        [title]="prop.split('|')[0]"
        download="{{ prop.split('|')[0] }}">{{ prop.split('|')[0] }}</a>
        <span *ngIf="!last"><br/></span>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'PDFVIEWER'">
      <ng-container *ngFor="let prop of property.PropertyDisplayFormat.split(',');index as i; let last= last">
        <div style="height: 60vh" *ngIf="property.PropertyFixedFileUrl">
          <ng2-pdfjs-viewer #pdfViewer 
          [pdfSrc]="property.PropertyFixedFileUrl[i]" 
          [viewBookmark]="false"
          [openFile]="false"
          [downloadFileName]="property.PropertyDisplay + '.pdf'"></ng2-pdfjs-viewer>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'COUNTDOWN'">
      <app-countdown-timer [setProperty]="property" (countdownEnd)="setCountdownEvent($event)"></app-countdown-timer>
    </ng-container>
    <ng-container *ngSwitchCase="'FIXEDMESSAGE'">
      <div *ngIf="fixedMessageList[property.PropertyId]" [innerHTML]="fixedMessageList[property.PropertyId] | safe_html"></div>
    </ng-container>
    <ng-container *ngSwitchCase="'HTMLEDITOR'">
      <app-html-editor [property]="property" (valueChange)="onValueChange(property, property.PropertyValue)"></app-html-editor>
    </ng-container>
    <ng-container *ngSwitchCase="'CHART'">
      <ng-container *ngIf="showChart">
        <app-chart [setChartObject]="property.PropertyValue" (valueChange)="onValueChange(property, property.PropertyValue)"></app-chart>
      </ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'COMBINATION'">
      <!-- combination of two combination properties, combobox, textbox, date, label  -->
        <ng-container *ngIf="property.PropertyDisplayFormat">
          <div class='flex-group'>
            <ng-container *ngFor="let prop of getCombinationProperty(property.PropertyId); index as x">
              <!-- <p (click)="checkProp(prop)">{{prop.PropertyFormControlType}}{{prop.PropertyIsEditable}}</p> -->
              <ng-container [ngSwitch]="prop.PropertyFormControlType.toUpperCase()">
                <div class="flex-custom-addon combination-item-{{x}}" [class.single]="getCombinationProperty(property.PropertyId).length == 1"
                [ngStyle]="{'flex': '0 0 ' + getPropertyWidth(property.PropertyId, x), 'max-width': getPropertyWidth(property.PropertyId, x), 
                'margin-right': (prop.PropertyFormControlType.toUpperCase() == 'LABEL') ? '5px' : '0px'}">
                  <ng-container *ngSwitchCase="'COMBOBOX'">
                    <ng-container *ngIf="prop.PropertyIsEditable == true;else isCombinationDisplay">
                      <ng-container *ngIf="prop.PropertyValidation; else noValidate">
                        <ng-select #select [items]="prop.PropertyValueSelection"
                          [id]="prop.PropertyName"
                          [ngClass]="{'detail-dropdown': true, 'is-invalid': submitted && PropertyValueDisplay.invalid, 'loading': retrievingLookupList }" 
                          (click)="onClickCombobox(prop, true); select.focus()"
                          (close)="onCloseCombobox()"
                          (blur)="onBlur(prop)"
                          (focus)="focus=true"
                          [isOpen]="prop.IsDropdownOpen && focus"
                          appendTo="{{ isPopupDetail ? 'body' : 'body' }}"
                          (change)="onValueChange(prop, $event.SelectionMapValue, PropertyValueDisplay)"
                          (keyup)="search(prop, $event)"
                          [clearable]="false" 
                          [searchable]="true"
                          bindLabel="SelectionDisplay"
                          bindValue="SelectionValue"
                          placeholder="Select {{prop.PropertyDisplay}}"
                          [(ngModel)]="prop.PropertyValue"
                          [name]="prop.PropertyName"
                          #PropertyValueDisplay="ngModel"
                          [ngModelOptions]="{ updateOn: 'blur' }" [required]="prop.PropertyValidation.IsMandatory">
                          <!-- <ng-template *ngIf="retrievingLookupList" ng-header-tmp>
                            <span class="loading-dropdown" title="loading dropdown list.." style="padding-left: 20px;">Loading dropdown list..</span>
                          </ng-template> -->
                        </ng-select>
                        <div *ngIf="PropertyValueDisplay.invalid" class="invalid-feedback">
                          <div *ngIf="PropertyValueDisplay.errors.required"><span [innerHTML]="prop.PropertyDisplay"></span> is required</div>
                        </div>
                      </ng-container>
                      <ng-template #noValidate>
                        <ng-select #select [items]="prop.PropertyValueSelection"
                          [id]="prop.PropertyName"
                          [ngClass]="{'detail-dropdown': true, 'loading': retrievingLookupList}"
                          (click)="onClickCombobox(prop, true); select.focus()"
                          (close)="onCloseCombobox()"
                          (blur)="onBlur(prop)"
                          (focus)="focus=true"
                          [isOpen]="prop.IsDropdownOpen && focus"
                          appendTo="{{ isPopupDetail ? 'body' : 'body' }}"
                          (change)="onValueChange(prop, $event.SelectionMapValue)"
                          (keyup)="search(prop, $event)"
                          [clearable]="false" 
                          [searchable]="true"
                          bindLabel="SelectionDisplay"
                          bindValue="SelectionValue"
                          placeholder="Select {{prop.PropertyDisplay}}"
                          value="prop.PropertyValue"
                          [(ngModel)]="prop.PropertyValue"
                          [name]="prop.PropertyName">
                          <!-- <ng-template *ngIf="retrievingLookupList" ng-header-tmp>
                            <span class="loading-dropdown" title="loading dropdown list.." style="padding-left: 20px;">Loading dropdown list..</span>
                          </ng-template> -->
                        </ng-select>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchCase="'MULTICOMBOBOX'">
                    <ng-container *ngIf="prop.PropertyValidation; else noValidate">
                      <ng-select #select
                        [items]="prop.PropertyValueSelection"
                        [id]="prop.PropertyName"
                        bindLabel="SelectionDisplay"
                        bindValue="SelectionValue"
                        [ngClass]="{ 'detail-dropdown': true, 'multi': true, 'is-invalid': submitted && PropertyValueArray.invalid, 'loading': retrievingLookupList }" 
                        (click)="onClickCombobox(prop); select.focus()"
                        (close)="onCloseCombobox()" 
                        (blur)="onBlur(prop)"
                        [isOpen]="prop.IsDropdownOpen"
                        appendTo="{{ isPopupDetail ? 'body' : 'body' }}"
                        (change)="onValueChange(prop, $event, PropertyValueArray)"
                        (keyup)="search(prop, $event)"
                        [clearable]="false"
                        [closeOnSelect]="false" 
                        [searchable]="true"
                        [multiple] = "true"
                        placeholder="Select {{prop.PropertyDisplay}}"
                        [(ngModel)]="prop.PropertyValueArray"
                        [name]="prop.PropertyName"
                        #PropertyValueArray="ngModel"
                        [required]="prop.PropertyValidation.IsMandatory ? prop.PropertyValidation.IsMandatory : null">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                          <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            <span class="ng-value-label">{{item.SelectionDisplay}}</span>
                          </div>
                          <div class="ng-value" *ngIf="items.length > 10">
                            <span class="ng-value-label">{{items.length - 10}} more...</span>
                          </div>
                        </ng-template>
                      </ng-select>
                      <div *ngIf="PropertyValueArray.invalid" class="invalid-feedback">
                        <div *ngIf="PropertyValueArray.errors.required">{{ prop.PropertyDisplay }} is required</div>
                      </div>
                    </ng-container>
                    <ng-template #noValidate>
                      <ng-select #select
                        [items]="prop.PropertyValueSelection"
                        [id]="prop.PropertyName"
                        [ngClass]="{ 'detail-dropdown': true, 'multi': true, 'loading': retrievingLookupList }" 
                        bindLabel="SelectionDisplay"
                        bindValue="SelectionValue"
                        (click)="onClickCombobox(prop); select.focus()"
                        (close)="onCloseCombobox()"
                        (blur)="onBlur(prop)"
                        [isOpen]="prop.IsDropdownOpen"
                        appendTo="{{ isPopupDetail ? 'body' : 'body' }}" 
                        (change)="onValueChange(prop, $event)"
                        (keyup)="search(prop, $event)"
                        [clearable]="false"
                        [closeOnSelect]="false" 
                        [searchable]="true"
                        [multiple] = "true"
                        placeholder="Select {{prop.PropertyDisplay}}"
                        [(ngModel)]="prop.PropertyValueArray"
                        [name]="prop.PropertyName">
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                          <div class="ng-value" *ngFor="let item of (items ? items.slice(0,10): [])">
                            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                            <span class="ng-value-label">{{item.SelectionDisplay}}</span>
                          </div>
                          <div class="ng-value" *ngIf="items.length > 10">
                            <span class="ng-value-label">{{items.length - 10}} more...</span>
                          </div>
                        </ng-template>
                      </ng-select>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngSwitchCase="'TEXTBOX'">
                    <ng-container *ngIf="prop.PropertyIsEditable == true;else isCombinationDisplay">
                      <!--<input *ngIf="!prop.IsAutoComplete" [attr.name]="prop.PropertyName" hidden>-->
                        <div *ngIf="prop.PropertyValidation; else noValidate" class="property-group">
                          <input #textbox type="text"
                          [id]="prop.PropertyName"
                          [ngClass]="{ 'form-control':true, 'is-invalid': submitted && PropertyValue.invalid, 'uppercase': prop.PropertyDisplayFormat == 'UPPER' }"
                          [value]="prop.PropertyValueDisplay" 
                          [name] = "prop.PropertyName"
                          [attr.name]="prop.PropertyName"
                          autocomplete="{{prop.IsAutoComplete ? prop.PropertyName : 'off'}}"
                          [(ngModel)]="prop.PropertyValueDisplay" 
                          (change)="onValueChange(prop, textbox.value, PropertyValue)"
                          #PropertyValue="ngModel"
                          [ngModelOptions]="{ updateOn: 'blur' }"
                          [pattern]="prop.PropertyValidation.PropertyFormat ? prop.PropertyValidation.PropertyFormat : null" 
                          [maxlength]="prop.PropertyValidation.PropertyLength == 0 ? null : prop.PropertyValidation.PropertyLength" [required]="prop.PropertyValidation.IsMandatory">
                          <span></span> <!-- required for validation purpose -->
                          <div *ngIf="PropertyValue.invalid" class="invalid-feedback">
                            <div *ngIf="PropertyValue.errors.required"><span [innerHTML]="prop.PropertyDisplay"></span> is required</div>
                            <div *ngIf="PropertyValue.errors.maxlength"><span [innerHTML]="prop.PropertyDisplay"></span> cannot be more than {{ prop.PropertyValidation.PropertyLength }}</div>
                            <div *ngIf="PropertyValue.errors.pattern">{{ prop.PropertyValidation.FormatValidationMessage }}</div>
                          </div>
                        </div>
                        <ng-template #noValidate>
                          <input #textbox type="text" 
                          [id]="prop.PropertyName"
                          [ngClass]="{'form-control': true, 'uppercase': prop.PropertyDisplayFormat == 'UPPER' }"
                          [attr.name]="prop.PropertyName"
                          autocomplete="{{prop.IsAutoComplete ? prop.PropertyName : 'off'}}"
                          [value]="prop.PropertyValueDisplay"
                          [name] = "prop.PropertyName"
                          [(ngModel)]="prop.PropertyValueDisplay" 
                          (change)="onValueChange(prop, textbox.value)">
                        </ng-template>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchCase="'DATE'">
                    <ng-container *ngIf="prop.PropertyIsEditable == true;else isCombinationDisplay">
                      <!--<input *ngIf="!prop.IsAutoComplete" [attr.name]="prop.PropertyName" hidden>-->
                      <div #dateInput *ngIf="prop.PropertyValidation; else noValidate" class="input-group date-group">
                        <input #textbox [ngClass]="{'form-control date-input': true, 'is-invalid': submitted && PropertyValueDisplay.invalid }" [matDatepicker]="picker"
                          [id]="prop.PropertyName"
                          [value]="dateValue"
                          [(ngModel)]="dateValue"
                          placeholder="Select Date - Format : {{prop.PropertyDisplayFormat}}"
                          (dateChange)="onValueChange(prop, textbox.value, PropertyValueDisplay)"
                          [name]="prop.PropertyName"
                          autocomplete="{{prop.IsAutoComplete ? prop.PropertyName : 'off'}}"
                          #PropertyValueDisplay="ngModel"
                          [ngModelOptions]="{ updateOn: 'blur' }"
                          [pattern]="prop.PropertyValidation.PropertyFormat ? prop.PropertyValidation.PropertyFormat : null" 
                          [maxlength]="prop.PropertyValidation.PropertyLength == 0 ? null : prop.PropertyValidation.PropertyLength"
                          [required]="prop.PropertyValidation.IsMandatory">
                        <mat-datepicker #picker></mat-datepicker>
                        <div class="input-group-append date-group" (click)="picker.open()" tabindex="0" (keyup.enter)="picker.open()">
                          <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-calendar"></i></span>
                        </div>
                        <div *ngIf="PropertyValueDisplay.invalid" class="invalid-feedback">
                          <div *ngIf="!prop.PropertyValidation.InvalidFormat && PropertyValueDisplay.errors.required"><span [innerHTML]="prop.PropertyDisplay"></span> is required</div>
                          <div *ngIf="!prop.PropertyValidation.InvalidFormat && PropertyValueDisplay.errors.matDatepickerParse"><span [innerHTML]="prop.PropertyDisplay"></span> is required</div>
                          <div *ngIf="(PropertyValueDisplay.errors.matDatepickerMin || PropertyValueDisplay.errors.DateMin) && prop.PropertyValidation.MinValue == '@CURRENTDATETIME'; else min">
                            <span [innerHTML]="prop.PropertyDisplay"></span> cannot be before current date time
                          </div>
                          <div *ngIf="prop.PropertyValidation.InvalidFormat">{{ prop.PropertyValidation.FormatValidationMessage }}</div>
                        </div>
                      </div>
                      <ng-template #noValidate>
                        <div #dateInput class='input-group'>
                          <input #textbox class="form-control date-input" [matDatepicker]="picker"
                          [id]="prop.PropertyName"
                          [value]="dateValue"
                          [(ngModel)]="dateValue"
                          [name]="prop.PropertyName"
                          autocomplete="{{prop.IsAutoComplete ? prop.PropertyName : 'off'}}"
                          placeholder="Select Date - Format : {{prop.PropertyDisplayFormat}}"
                          (dateChange)="onValueChange(prop, textbox.value)"
                          [ngModelOptions]="{ updateOn: 'blur' }">
                          <mat-datepicker #picker></mat-datepicker>
                          <div class="input-group-append date-group" (click)="picker.open()" tabindex="0" (keyup.enter)="picker.open()">
                            <span class="input-group-text" style="cursor: pointer;"><i class="fa fa-calendar"></i></span>
                          </div>
                        </div>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngSwitchCase="'LABEL'">
                    <ng-container *ngIf="property.IsInputLabel; else label">
                      <div class="input-label-prepend">
                        <span class="input-group-text input-label" [id]="prop.PropertyName">{{prop.PropertyValueDisplay}}</span>
                      </div>
                    </ng-container>
                    <ng-template #label>
                      <span [id]="prop.PropertyName" [id]="prop.PropertyName">{{prop.PropertyValueDisplay}}</span>
                    </ng-template>
                  </ng-container>
                  <ng-template #isCombinationDisplay>
                    <ng-container *ngIf="prop.PropertyFormControlType.toUpperCase() == 'LABEL'; else withBorder">
                      <span>{{prop.PropertyValueDisplay}}</span>
                    </ng-container>
                    <ng-template #withBorder>
                      <div class="input-label-prepend">
                        <span class="input-group-text input-label" [id]="prop.PropertyName">{{prop.PropertyValueDisplay}}</span>
                      </div>
                    </ng-template>
                  </ng-template>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
    </ng-container>
    <div *ngSwitchCase="'DATASET'" class="dataset-row">
      <app-sub-summary #subsummary [propertyId]='property.PropertyId'
      [parentId]="componentId" (subSelectedId)='onSelectedItem($event)' [isSubSummary]="true" [setForceRefresh]="true" [isDataSet]="true"></app-sub-summary>
    </div>
  </ng-container>

  <ng-template #isDisplay>
    <span *ngIf="property.PropertyFormControlType.toUpperCase() == 'MULTICOMBOBOX' || property.PropertyFormControlType.toUpperCase() == 'HIERARCHYMULTISELECT' 
    || property.PropertyFormControlType.toUpperCase() == 'HIERARCHYSINGLESELECT' || property.PropertyFormControlType.toUpperCase() == 'MULTITEXT'; else dateLabel" [id]="property.PropertyName">
        {{property.PropertyValueDisplayArray}}
    </span>
    <ng-template #dateLabel>
      <span *ngIf="property.PropertyFormControlType.toUpperCase() == 'DATE'; else cb">
        {{ dateValue == 'Invalid Date' ? '' : dateValue | date: property.PropertyDisplayFormat }}
      </span>
    </ng-template>
    <ng-template #cb>
      <ng-container *ngIf="property.PropertyFormControlType.toUpperCase() == 'CHECKBOX'; else other">
        <div *ngFor="let value of property.PropertyValueSelection" class="mat-checkbox-container">
          <mat-checkbox
          [disabled]="true"
          [attr.name]="property.PropertyName"
          (change)="onValueChange(property, $event)" 
          [value]="value.SelectionValue" 
          [checked]="value.IsSelected == true">{{ value.SelectionDisplay }}</mat-checkbox>
        </div>
      </ng-container>
    </ng-template>
    <ng-template #other>
      <span [innerHTML]="property.PropertyValueDisplay" class="display-prop" [id]="property.PropertyName"></span>
    </ng-template>
    <!-- <ng-container *ngIf="property.PropertyName == 'ItemDescription'">
      <app-related [documentTypeCode]="detailObject.DocumentTypeCode" [baseDocumentType]="documentType" [baseDocumentId]="documentId" [parentComponentId]="componentId" [relationType]="'PRToProduct'"></app-related>
    </ng-container> -->
  </ng-template>
</ng-container>